module.exports = __webpack_public_path__ + "img/2023082808344796585f.aa157714.jpg";